<div class="modal-header">
    @if (layer) {
    <h4 class="modal-title" id="modal-title">{{ getDisplayName(layer) }}</h4>
    }
    <button type="button" class="btn-close" aria-describedby="modal-title" (click)="dismiss()"></button>
</div>
<div class="modal-body">
    <div>
        <h6><strong>{{ lang.GetValue("Layerlist.Descrip") }}</strong></h6>

        @if (text) {
        <p>{{ text }}</p>
        } @if (!text) {
        <p [trv-loading]="true"></p>
        }
    </div>

    @if (layer && trvMapService.trvMap?.trvLayer?.hasLayerData(layer, "layerCategory")) {
        <div class="lnk">
            <h6><strong>Nätkategori:</strong></h6>
            {{trvMapService.trvMap?.trvLayer?.getLayerData(layer, 'layerCategory')}}
        </div>
        
    }

    @if (layer && trvMapService.trvMap?.trvLayer?.hasLayerData(layer, "geoDataMetaId")) {
        <div class="lnk">
            <h6><strong>Information geodataportalen:</strong></h6>
            <a [href]="'https://www.geodata.se/geodataportalen/srv/swe/catalog.search#/metadata/' + trvMapService.trvMap?.trvLayer?.getLayerData(layer, 'geoDataMetaId') " target="_blank">Länk till geodata</a>
        </div>
        
    }

    @if (layerVisibleFrom) {
    <div>
        <h6><strong>{{ lang.GetValue("Layerlist.VisibleScale") }}</strong></h6>
        <p>1:{{ layerVisibleFrom }}</p>
    </div>
    } @if (legendGraphics) {
    <div>
        <h6><strong>{{ lang.GetValue("Layerlist.Legend") }}</strong></h6>
        <div></div>
        <img alt="legend grafik" [src]="getLegendGraphics()" />
    </div>
    } @if (layer) {
    <div>
        <h6><strong>{{ lang.GetValue("Layerlist.Opacity") }}</strong></h6>
        <div style="width: 100%">
            <mat-slider min="0" max="1" step="0.05" discrete="thumbLabel">
                <input (input)="onOpacityChange($event)" value="{{ layer.opacity ? layer.opacity : 1 }}" matSliderThumb />
            </mat-slider>
        </div>
    </div>
    }
    <div>
        <h6>
            <strong>Z-index:</strong>
            {{ layer?.zIndex }}
        </h6>
        <div>
            <div>
                <button type="button" class="btn btn-primary btn-sm" (click)="trvMapService.trvMap?.trvLayer?.moveLayerToTop(layer!)">
                    {{ lang.GetValue("Layerlist.TopLayer") }}
                </button>
            </div>
        </div>
    </div>
    @if(environment.application == "NjdbPåWebb") {
    <div class="d-flex align-items-center mt-2"
    [trvTooltip]="nvdbNavigationService.toolTipTextLastFeatureUpdate" [position]="toolTipPositions"
    >
        <app-svg-icon style="fill: #1e5c88" [svgIcon]="circleInfoIcon"></app-svg-icon>
        <span style="font-style: italic; margin-left: 0.5rem">
            @if (environment.application == "NjdbPåWebb") {
                {{
                    nvdbNavigationService.formattedLastFeatureUpdateNVDB
                        ? 'Data uttaget från NJDB: ' + nvdbNavigationService.formattedLastFeatureUpdateNVDB
                        : 'Kunde inte hämta datum då NJDB uppdaterades'
                }}
                } 
                @else {
                {{
                    nvdbNavigationService.formattedLastFeatureUpdateNVDB
                        ? 'Data uttaget från NVDB: ' + nvdbNavigationService.formattedLastFeatureUpdateNVDB
                        : 'Kunde inte hämta datum då NVDB uppdaterades'
                }}
                }
        </span>
    </div>
}

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-link" (click)="close()">{{ lang.GetValue("MapMenu.Close") }}</button>
</div>
